import React from "react";

type PopupModalProps = {
  isOpen: boolean;
  setOpen: any;
  children: React.ReactNode;
  title?: string;
};

const PopupModal: React.FC<
  PopupModalProps
> = ({
  isOpen,
  setOpen,
  children,
  title
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
    >
      <div
        className={`${title==="OnePager" ? "modal-content-onepager" :title=="CancerCareDeck"?"modal-content-pdf": title==="videoComments"?"modal-content-comments":"modal-content"}`}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <button
          className="close-btn"
          onClick={() => setOpen(false)}
        >
          ✕
        </button>

        {children}
      </div>
    </div>
  );
};

export default PopupModal;